import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { VersionListItem } from "~/components/AssetModal/AssetModalFooter/VersionList/VersionListContent/VersionListItem/VersionListItem";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
export const PublicVersionListItem = /*#__PURE__*/ memo((param)=>{
    let { ...rest } = param;
    const { permissions } = usePublicPermissions();
    return /*#__PURE__*/ _jsx(VersionListItem, {
        ...rest,
        permissions: permissions
    });
});
PublicVersionListItem.displayName = "PublicVersionListItem";
